module.exports = __webpack_public_path__ + "static/media/ZMCC.8ac0dbbe.pdf";